import { Columns } from '@app/components/simple-table/simple-table.component';

export const additionalQuestionsTableColumns: Columns[] = [
    { columnName: 'applicant-tracker.components.simple-table.questions', columnSpan: 'columns-5' },
    { columnName: 'applicant-tracker.components.simple-table.type', columnSpan: 'columns-2' },
    { columnName: 'applicant-tracker.components.simple-table.requirement', columnSpan: 'columns-2' },
    { columnName: 'applicant-tracker.components.simple-table.answerVisibility', columnSpan: 'columns-2' },
];
